<template>
    <Header></Header>

    <div class="container sub_page _intro">
        <section class="sub_page_tit">
            <div class="deco_wrap">
                <i class="deco_01 _xsmall spin3"><img src="img/b_icon_03.png" /></i>
                <i class="deco_02 _small blink_zoom1"><img src="img/b_icon_01.png" /></i>
                <i class="deco_03 _xsmall spin_blink2"><img src="img/b_icon_03.png" /></i>
                <i class="deco_04 _small blink_blink3"><img src="img/b_icon_01.png" /></i>
                <i class="deco_character"><img src="img/intro_icon.png" /></i>
            </div>
            <div class="banner_wrap wrap_1120">
                <h2>소개</h2>
            </div>
            <div class="sub_menu_tab wrap_1120">
                <button class="only_768" @click="subMenuTab" :class="{ active: state.subMenuOpen }">{{ state.subMenuName }}</button>
                <ul :class="{ active: state.subMenuOpen }">
                    <li @click="changeTab(1)" :class="[state.tab === 1 ? 'active' : '']">
                        <a href="javascript:void(0)">반성매매 시민참여 플랫폼</a>
                    </li>
                    <li @click="changeTab(2)" :class="[state.tab === 2 ? 'active' : '']"><a href="javascript:void(0)">다시함께상담센터</a></li>
                    <li @click="changeTab(3)" :class="[state.tab === 3 ? 'active' : '']"><a href="javascript:void(0)">자주 묻는 질문</a></li>
                </ul>
            </div>
        </section>

        <platform v-if="state.tab === 1"></platform>
        <centerIntroduce v-if="state.tab === 2"></centerIntroduce>
        <FaqList v-if="state.tab === 3"></FaqList>
    </div>

    <Footer></Footer>
</template>

<script lang="ts" config>
    import {
        Header,
        Footer,
        reactive,
        globalStore,
        onMounted,
        watch,
        centerIntroduce,
        faqList,
        userStore,
        useRoute,
        router,
        platform,
    } from "@/BaseComponent";

    export default {
        components: { Header, Footer, FaqList: faqList, centerIntroduce, platform },
        setup() {
            const route = useRoute();
            const global = globalStore();
            const state = reactive({
                tab: 0 as number,
                subMenuOpen: false as boolean,
                subMenuName: "반성매매 시민참여 플랫폼" as string,
            });

            onMounted(() => {
                if (global.introTab > 0) changeTab(global.introTab);
                else changeTab(1);

                if (route.query.type) {
                    const number = Number(route.query.type);
                    changeTab(number);
                }
            });

            watch(
                () => route.query.type,
                () => {
                    const type = Number(route.query.type);
                    if (route.query.type) {
                        if (type && typeof type === "number" && !isNaN(type)) {
                            state.tab = type;
                        } else {
                            state.tab = 1;
                        }
                    } else {
                        state.tab = 1;
                    }
                },
            );

            watch(state, () => {
                if (global.introTab !== state.tab) global.setIntroTab(state.tab);
            });

            watch(global, () => {
                if (global.introTab !== state.tab) changeTab(global.introTab);
            });

            const changeTab = (tab: number) => {
                state.tab = tab;
                router.push({ path: "/intro", query: { type: state.tab } });
                state.subMenuOpen = false;
                switch (tab) {
                    case 1:
                        state.subMenuName = "반성매매 시민참여 플랫폼";
                        break;
                    case 2:
                        state.subMenuName = "다시함께상담센터";
                        break;
                    case 3:
                        state.subMenuName = "자주 묻는 질문";
                        break;
                }
            };
            const subMenuTab = () => {
                if (window.innerWidth <= 768) {
                    state.subMenuOpen = !state.subMenuOpen;
                }
            };
            return { state, changeTab, subMenuTab };
        },
    };
</script>
